<template>
  <div class="advantage-card">
    <div class="card-moudles" :class="{mulitrow : advantages.mulitrow}">
      <div class="advantage-title" v-if="advantages.title">
        <span class="line lline"><i /><i /></span>
        <span class="word">{{ advantages.title }}</span>
        <span class="line rline"><i /><i /></span>
      </div>
      <div class="advantage-card-list">
        <div v-for="(item, index) in advantages.list" class="advantage-card-item" :key="index" @mouseover="hoverIndex = index" @mouseout="hoverIndex = -1" :class="{'hoverStyle':index == hoverIndex}">
          <p class="title">
            <span v-if="item.iconname" class="icon-autobi" :class="item.iconname"></span>
            <span class="word" :class="{'hasicon': item.iconname}">{{ item.title }}</span>
          </p>
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    advantages: {
      type: Object,
      default: function () { return [] }
    },
    planeStyle: Boolean
  },
  data () {
    return {
      hoverIndex: -1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.advantage-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  margin-top: 70px;
  margin-bottom: 70px;
}
.advantage-title .word {
  font-size: 30px;
  font-family: 'PingFangSC-Medium';
  color: #20253F;
}
.advantage-title .lline {
  margin-right: 26px;
}
.advantage-title .rline {
  margin-left: 26px;
}
.advantage-title .line i {
  display: block;
  height: 1px;
  transform: scaleX(-1);
  background: #CACED5;
}
.advantage-title .line i:first-child {
  width: 71px;
}
.advantage-title .lline i:first-child {
  float: right;
}
.advantage-title .line i:last-child {
  width: 139px;
  margin-top: 11px;
}
.advantage-card-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 20px;
}
.advantage-card-item {
  /* float: left; */
  width: 31.73%;
  background: #fff;
  border: 1px solid rgba(151, 151, 151, 0.15);
  border-radius: 8px;
  margin: 0 10px 24px;
  padding-bottom: 32px;
  background-repeat: no-repeat;
  background-size: 35%;
  background-position: bottom right;
  font-family: 'PingFangSC-Regular';
}
.autoclound-app .advantage-card-item {
  background: none;
  border: none;
}
/* .advantage-card-item:nth-child(odd) {
  background-image: url('./../assets/images/_icon-card-bg-blue.png');
}
.advantage-card-item:nth-child(even) {
  background-image: url('./../assets/images/_icon-card-bg-yellow.png');
} */
.advantage-card-item:nth-child(3n) {
  margin-right: 0;
}
.mulitrow .advantage-card-list {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.advantage-card-item .title {
  height: 40px;
  overflow: hidden;
  display: flex;
  font-size: 20px;
  color: #20253F;
  margin: 32px 23px 16px;
}
.advantage-card-item .desc {
  margin: 0 23px;
  font-size: 14px;
  color: #6F778F;
  line-height: 25px;
}
.hoverStyle {
  box-shadow: 0 8px 23px 0 rgba(139, 139, 139, 0.16);
  transition: box-shadow .3s;
}
.autoclound-app .hoverStyle {
  background: #FFFFFF;
  box-shadow: 0 3px 15px 2px rgba(139,139,139,0.25);
}
.advantage-card-item .title .word {
  flex: 1;
  line-height: 40px;
}
.advantage-card-item .title .hasicon {
  flex: 1;
  line-height: 40px;
  margin-left: -40px;
}
.icon-autobi {
  display: inline-block;
  width: 80px;
  height: 80px;
  transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
  -o-transform: scale(0.5);
  transform-origin: top left;
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left;
  position: relative;
  left: -4px;
}
.icon-autobi-01 {
  background-image: url('./../assets/images/_icon-autobi-01.png');
}
.icon-autobi-02 {
  background-image: url('./../assets/images/_icon-autobi-02.png');
}
.icon-autobi-03 {
  background-image: url('./../assets/images/_icon-autobi-03.png');
}
.icon-autobi-04 {
  background-image: url('./../assets/images/_icon-autobi-04.png');
}
.icon-autobi-05 {
  background-image: url('./../assets/images/_icon-autobi-05.png');
}
.icon-autobi-06 {
  background-image: url('./../assets/images/_icon-autobi-06.png');
}
.icon-autobi-07 {
  background-image: url('./../assets/images/_icon-autobi-07.png');
}
.icon-autobi-08 {
  background-image: url('./../assets/images/_icon-autobi-08.png');
}
.icon-autobi-09 {
  background-image: url('./../assets/images/_icon-autobi-09.png');
}
.icon-autobi-10 {
  background-image: url('./../assets/images/_icon-autobi-10.png');
}
.icon-autobi-11 {
  background-image: url('./../assets/images/_icon-autobi-11.png');
}
.icon-autobi-12 {
  background-image: url('./../assets/images/_icon-autobi-12.png');
}
.icon-autobi-13 {
  background-image: url('./../assets/images/_icon-autobi-13.png');
}
.icon-autobi-14 {
  background-image: url('./../assets/images/_icon-autobi-14.png');
}
.icon-autobi-15 {
  background-image: url('./../assets/images/_icon-autobi-15.png');
}
.icon-autobi-16 {
  background-image: url('./../assets/images/_icon-autobi-16.png');
}

.icon-cloud-01 {
  background-image: url('./../assets/images/_icon-cloud-01.png');
}
.icon-cloud-02 {
  background-image: url('./../assets/images/_icon-cloud-02.png');
}
.icon-cloud-03 {
  background-image: url('./../assets/images/_icon-cloud-03.png');
}
.icon-cloud-04 {
  background-image: url('./../assets/images/_icon-cloud-04.png');
}
.icon-cloud-05 {
  background-image: url('./../assets/images/_icon-cloud-05.png');
}
.icon-cloud-06 {
  background-image: url('./../assets/images/_icon-cloud-06.png');
}
.icon-cloud-07 {
  background-image: url('./../assets/images/_icon-cloud-07.png');
}
.icon-cloud-08 {
  background-image: url('./../assets/images/_icon-cloud-08.png');
}
.icon-cloud-09 {
  background-image: url('./../assets/images/_icon-cloud-09.png');
}
.icon-cloud-10 {
  background-image: url('./../assets/images/_icon-cloud-10.png');
}
.icon-cloud-11 {
  background-image: url('./../assets/images/_icon-cloud-11.png');
}
.icon-cloud-12 {
  background-image: url('./../assets/images/_icon-cloud-12.png');
}
.icon-cloud-13 {
  background-image: url('./../assets/images/_icon-cloud-13.png');
}
.icon-rs-01 {
  background-image: url('./../assets/images/_icon-rs-01.png');
}
.icon-rs-02 {
  background-image: url('./../assets/images/_icon-rs-02.png');
}
.icon-rs-03 {
  background-image: url('./../assets/images/_icon-rs-03.png');
}
.icon-rs-04 {
  background-image: url('./../assets/images/_icon-rs-04.png');
}
.icon-rs-05 {
  background-image: url('./../assets/images/_icon-rs-05.png');
}
.icon-rs-06 {
  background-image: url('./../assets/images/_icon-rs-06.png');
}
.icon-rs-07 {
  background-image: url('./../assets/images/_icon-rs-07.png');
}
.icon-rs-08 {
  background-image: url('./../assets/images/_icon-rs-08.png');
}
.icon-rs-09 {
  background-image: url('./../assets/images/_icon-rs-09.png');
}
.icon-zb-01 {
  background-image: url('./../assets/images/_icon-zb-01.png');
}
.icon-zb-02 {
  background-image: url('./../assets/images/_icon-zb-02.png');
}
.icon-zb-03 {
  background-image: url('./../assets/images/_icon-zb-03.png');
}
.icon-zb-04 {
  background-image: url('./../assets/images/_icon-zb-04.png');
}
.icon-zb-05 {
  background-image: url('./../assets/images/_icon-zb-05.png');
}
.icon-zb-06 {
  background-image: url('./../assets/images/_icon-zb-06.png');
}
.icon-zb-07 {
  background-image: url('./../assets/images/_icon-zb-07.png');
}
.icon-zb-08 {
  background-image: url('./../assets/images/_icon-zb-08.png');
}
.icon-zb-09 {
  background-image: url('./../assets/images/_icon-zb-09.png');
}
.icon-zb-10 {
  background-image: url('./../assets/images/_icon-zb-10.png');
}
.icon-zb-11 {
  background-image: url('./../assets/images/_icon-zb-11.png');
}
.icon-zb-12 {
  background-image: url('./../assets/images/_icon-zb-12.png');
}
.icon-zb-13 {
  background-image: url('./../assets/images/_icon-zb-13.png');
}
.icon-push-01 {
  background-image: url('./../assets/images/_icon-push-01.png');
}
.icon-push-02 {
  background-image: url('./../assets/images/_icon-push-02.png');
}
.icon-push-03 {
  background-image: url('./../assets/images/_icon-push-03.png');
}
.icon-push-04 {
  background-image: url('./../assets/images/_icon-push-04.png');
}
.icon-push-05 {
  background-image: url('./../assets/images/_icon-push-05.png');
}
.icon-push-06 {
  background-image: url('./../assets/images/_icon-push-06.png');
}
.icon-push-07 {
  background-image: url('./../assets/images/_icon-push-07.png');
}
.icon-push-08 {
  background-image: url('./../assets/images/_icon-push-08.png');
}
.icon-push-09 {
  background-image: url('./../assets/images/_icon-push-09.png');
}
.icon-push-10 {
  background-image: url('./../assets/images/_icon-push-10.png');
}
.icon-flash-01 {
  background-image: url('./../assets/images/_icon-flash-01.png');
}
.icon-flash-02 {
  background-image: url('./../assets/images/_icon-flash-02.png');
}
.icon-flash-03 {
  background-image: url('./../assets/images/_icon-flash-03.png');
}
.icon-flash-04 {
  background-image: url('./../assets/images/_icon-flash-04.png');
}
.icon-flash-05 {
  background-image: url('./../assets/images/_icon-flash-05.png');
}
.icon-flash-06 {
  background-image: url('./../assets/images/_icon-flash-06.png');
}
.icon-flash-07 {
  background-image: url('./../assets/images/_icon-flash-07.png');
}
.icon-flash-08 {
  background-image: url('./../assets/images/_icon-flash-08.png');
}
.icon-flash-09 {
  background-image: url('./../assets/images/_icon-flash-09.png');
}
.icon-flash-10 {
  background-image: url('./../assets/images/_icon-flash-10.png');
}
.icon-flash-11 {
  background-image: url('./../assets/images/_icon-flash-11.png');
}
.icon-player-01 {
  background-image: url('./../assets/images/_icon-player-01.png');
}
.icon-player-02 {
  background-image: url('./../assets/images/_icon-player-02.png');
}
.icon-player-03 {
  background-image: url('./../assets/images/_icon-player-03.png');
}
.icon-player-04 {
  background-image: url('./../assets/images/_icon-player-04.png');
}
.icon-player-05 {
  background-image: url('./../assets/images/_icon-player-05.png');
}
.icon-player-06 {
  background-image: url('./../assets/images/_icon-player-06.png');
}
.icon-player-07 {
  background-image: url('./../assets/images/_icon-player-07.png');
}
.icon-player-08 {
  background-image: url('./../assets/images/_icon-player-08.png');
}
.icon-player-09 {
  background-image: url('./../assets/images/_icon-player-09.png');
}
.icon-player-10 {
  background-image: url('./../assets/images/_icon-player-10.png');
}
.icon-player-11 {
  background-image: url('./../assets/images/_icon-player-11.png');
}
.icon-player-12 {
  background-image: url('./../assets/images/_icon-player-12.png');
}
</style>



// WEBPACK FOOTER //
// src/components/advantage.vue